import { useState, useEffect, useCallback } from 'react'
import { buscarJogosComSpreads } from '../lib/espn'
import { supabase } from '../lib/supabase'
import { useAuth } from '../contexts/AuthContext'

export function useJogosDaSemana(semanaId, semanaNumero, ano = 2026, tipoTemporada = 2, spreadsCongelados = false) {
  const [jogos, setJogos] = useState([])
  const [loading, setLoading] = useState(true)
  const [erro, setErro] = useState(null)

  const carregarJogos = useCallback(async () => {
    if (!semanaId || !semanaNumero) return
    setLoading(true); setErro(null)
    try {
      const { data: jogosDB } = await supabase
        .from('jogos').select('*').eq('semana_id', semanaId).order('horario', { ascending: true })

      if (jogosDB?.length > 0) {
        setJogos(jogosDB)
        setLoading(false)  // mostra banco imediatamente; ESPN roda em segundo plano
        if (spreadsCongelados) return
      }

      const { sucesso, jogos: jogosESPN } = await buscarJogosComSpreads(ano, semanaNumero, tipoTemporada)

      if (sucesso && jogosESPN?.length > 0) {
        for (const jogo of jogosESPN) {
          if (!jogo.time_casa || !jogo.time_visitante) continue
          const jogoData = {
            semana_id: semanaId, espn_event_id: jogo.espn_event_id,
            time_casa: jogo.time_casa, time_visitante: jogo.time_visitante,
            nome_casa: jogo.nome_casa, nome_visitante: jogo.nome_visitante,
            spread_casa: jogo.spread_casa, spread_visitante: jogo.spread_visitante,
            horario: jogo.horario,
          }
          if (jogo.resultado) jogoData.resultado = jogo.resultado
          await supabase.from('jogos').upsert(jogoData, { onConflict: 'semana_id,time_casa,time_visitante' })
        }
        const { data: atualizados } = await supabase
          .from('jogos').select('*').eq('semana_id', semanaId).order('horario', { ascending: true })
        setJogos(atualizados || jogosESPN)
      }
    } catch (err) {
      setErro('Erro ao carregar jogos.')
    } finally { setLoading(false) }
  }, [semanaId, semanaNumero, ano, tipoTemporada, spreadsCongelados])

  useEffect(() => { carregarJogos() }, [carregarJogos])
  return { jogos, loading, erro, recarregar: carregarJogos }
}

export function useSemanaAtual() {
  const { ligaAtual } = useAuth()
  const [semana, setSemana] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function carregar() {
      if (!ligaAtual?.id) { setLoading(false); return }
      // Prioridade: semana com picks abertos; fallback: primeira não processada
      const { data: aberta } = await supabase
        .from('semanas').select('*')
        .eq('liga_id', ligaAtual.id)
        .eq('picks_abertos', true)
        .order('numero', { ascending: true })
        .limit(1).maybeSingle()
      if (aberta) { setSemana(aberta); setLoading(false); return }
      const { data: naoProcessada } = await supabase
        .from('semanas').select('*')
        .eq('liga_id', ligaAtual.id)
        .eq('resultados_processados', false)
        .order('numero', { ascending: true })
        .limit(1).maybeSingle()
      setSemana(naoProcessada)
      setLoading(false)
    }
    carregar()
  }, [ligaAtual?.id])

  return { semana, loading }
}
